/**
 * Also Bought 위젯 커스텀 (Combowise 앱과 무관 — 파일명만 combowise)
 * - .cbb-also-bought-product 카드의 담기 버튼을 "VIEW MORE"로 바꾸고, 클릭 시 상품 페이지로 이동
 * - 위젯이 렌더될 때까지 1초 간격으로 확인 후, 찾으면 중단
 * - Also Bought 사용 중에는 삭제 금지 / 로드 위치: layout/theme.liquid
 */

(function() {
    let timer = setInterval(function() {
        try {
            let cbbAlsoBoughtProduct = document.querySelectorAll('.cbb-also-bought-product');
    
            if (cbbAlsoBoughtProduct && cbbAlsoBoughtProduct.length) {
                clearTimeout(timer);
    
                for (let i = 0; i < cbbAlsoBoughtProduct.length; i++) {
                    const link = cbbAlsoBoughtProduct[i].querySelector('.cbb-also-bought-product-image-link').dataset.href;
                    const atc = cbbAlsoBoughtProduct[i].querySelector('.cbb-also-bought-add-to-cart-button');
                    const newAtc = atc.cloneNode(true);
                    cbbAlsoBoughtProduct[i].replaceChild(newAtc, atc);
                    if (newAtc.children.length) {
                        newAtc.children[0].innerText = "VIEW MORE";
                    } else {
                        newAtc.innerText = "VIEW MORE";
                    }
                    newAtc.addEventListener('click', function() {
                        window.location.href = link;
                    });
                }
            }
        } catch (err) {
            console.error('Combowise cart custom script error: ', err);
            clearTimeout(timer);
        }
    }, 1000);
})();
